<!-- src/components/ChatInputText.vue -->
<template>
  <div class="chat-input">
    <input
      v-model="currentQuestion"
      @keyup.enter="askQuestion"
      placeholder="How can I help?"
    />
    <button @click="askQuestion" :disabled="answerLoading">
      <span>Ask</span>
    </button>
  </div>
</template>

<script lang="ts">
import { computed, ref } from 'vue';

import { useAppStore } from '@/store/appStore';
import { useQuestionStore } from '../store/questionStore';

export default {
  setup() {
    const { prompt, view } = useAppStore();
    const questionStore = useQuestionStore();
    // Use computed to ensure reactivity is preserved
    const answerLoading = computed(() => questionStore.answerLoading);
    const currentQuestion = ref<string>('');

    const askQuestion = () => {
      if (currentQuestion.value.trim()) {
        const question = currentQuestion.value;
        questionStore.fetchAnswer(question, prompt, view);
        currentQuestion.value = '';
      }
    };

    return {
      currentQuestion,
      askQuestion,
      answerLoading
    };
  }
};
</script>

<style scoped>
.chat-input {
  display: flex;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 10px 0px;
  justify-content: center;
}

@media (max-width: 500px) {
  .chat-input {
    width: 100%;
    max-width: 100%;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 25px;
  }
}

input {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid black;
  margin-right: 0;
  height: 20px;
}

input:focus {
  outline: none;
  border-color: black;
}

button {
  padding: 9px;
  border: 1px solid black;
  font-size: 1rem;
  border-left: 0;
  background-color: rgb(0, 121, 52);
  color: white;
  cursor: pointer;
}
</style>
